$(function() {
	if ($('#form1_artist').length) {
		$.getJSON('/artist-names', function(data) {
			$('#form1_artist').find('option').last().remove();
			for (var i = 0; i < data.length; i++) {
				$('#form1_artist').append($('<option>').val(data[i]).html(data[i]));
			}
		});
	}
});